export const motionFadeUp = {
    initial: {
      opacity: 0,
      y: 200,
    },
    enter: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5, // Adjusted duration for smoother animation
        ease: [0.42, 0, 0.58, 1], // Easing function for a natural flow
      },
    },
  };
  